import { FormEvent, FunctionComponent, memo, useState } from 'react';
import styled from 'styled-components';
import {
  ArrowRightMd,
  Button,
  radiusHelper,
  spacingHelper,
  TextInput,
  typographyHelper,
} from '@property.com.au/ui-kit';

const Form = styled.form`
  padding: ${spacingHelper('large medium')};
  position: relative;
`;

const Input = styled(TextInput)`
  ${typographyHelper('body01')};
  & > ::after {
    border-radius: ${radiusHelper('extraLarge')};
  }
`;

const Send = styled(Button)`
  position: absolute;
  margin-top: ${spacingHelper('small')};
  top: ${spacingHelper('medium')};
  right: ${spacingHelper('large')};
`;

const SessionText = styled.div`
  position: absolute;
  bottom: ${spacingHelper('twoExtraSmall')};
  left: 50%;
  text-align: center;
  transform: translateX(-50%);
  ${typographyHelper('caption')}
  width: 100%;
`;

interface ChatFormProps {
  loading: boolean;
  sessionId: string | null;
  onSubmit: (e: string) => void;
}

const PureChatForm: FunctionComponent<ChatFormProps> = ({ loading, onSubmit, sessionId }) => {
  const [input, setInput] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!input.trim()) return;
    onSubmit(input);
    setInput('');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        placeholder="Message"
        name="pca-chat-input"
        label="PCA Chat Input"
        hideLabel
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <Send
        type="submit"
        disabled={loading || !input.trim()}
        variant="primary"
        icon={<ArrowRightMd />}
        hideLabel
        compact
        sizeVariant="medium"
      >
        Send
      </Send>
      {sessionId && <SessionText>Session id: {sessionId}</SessionText>}
    </Form>
  );
};

export const ChatForm = memo(PureChatForm);
